/**
 * Message Type
 */
export enum MESSAGE_TYPE {
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  AUDIO = 'audio',
  VIDEO = 'video',
}

/**
 * Media Message Attachment
 */
export type MediaAttachment = {
  /**
   * media message extension
   */
  extension: string;
  /**
   * media message mime type
   */
  mimeType: string;
  /**
   * media message name
   */
  name: string;
  /**
   * media message size
   */
  size: number;
  /**
   * media message url
   */
  url: string;
  placeholderSrc: {
    base64: string;
  };
  originalDimension: {
    width: number;
    height: number;
  };
};

/**
 * Media Message Metadata
 */
export type MediaMetadata = {
  /**
   * media message extension
   */
  ext: string;
  /**
   * media message type
   */
  type:
    | MESSAGE_TYPE.AUDIO
    | MESSAGE_TYPE.FILE
    | MESSAGE_TYPE.IMAGE
    | MESSAGE_TYPE.VIDEO;
  /**
   * image original dimension
   */
  originalDimension?: {
    /**
     * image height
     */
    height: number;
    /**
     * image width
     */
    width: number;
  };
  /**
   * image placeholder source
   */
  placeholderSrc?: {
    /**
     * image base64
     */
    base64: string;
  };
  /**
   * file name
   */
  name?: string;
};
